// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------

import { atualizarCotaUsuario } from "../services/atualizarCotaUsuarioService";
// --------------------- Import Interface ---------------------

import { CotaUsuario } from "../interfaces/CotaUsuario";

export const useAtualizarDadosAnuncioPropriedade = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const atualizarDadosAnuncioPropriedade = async (
    cotaUsuarioId: number | undefined | null,
    maisInfo: CotaUsuario
  ) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const maisInfos = await atualizarCotaUsuario(cotaUsuarioId, maisInfo);

      if (cotaUsuarioId && maisInfos) {
        setSuccess("Os dados foram atualizados!");
      } else {
        setError("Não foi possível atualizar os dados!");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return {
    atualizarDadosAnuncioPropriedade,
    isLoading,
    isSuccess,
    error,
    success,
  };
};
